import React from "react";
import { clsx } from "clsx";
import "./InventoryTabs.scss";

const InventoryTabs = ({ tabs, activeTab, setActiveTab }) => {
  return (
    <div className="inventory-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={clsx(
            "inventory-tab",
            activeTab === tab.id ? "active" : ""
          )}
          onClick={() => setActiveTab(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default InventoryTabs;
